<template>
  <BasicButton
    :appearance="appearance || (reaction.hasReacted ? 'reaction-active' : 'reaction')"
    :href="href"
    @click="$emit('click', $event)"
  >
    <InlineAlign
      v-if="$slots.default"
      gap="small"
    >
      <template #start>
        <img
          width="18"
          height="18"
          :src="reaction.image"
          :alt="reaction.title"
        >
      </template>
      <template #default>
        <slot />
      </template>
    </InlineAlign>
    <img
      v-else
      width="18"
      height="18"
      :src="reaction.image"
      :alt="reaction.title"
    >
  </BasicButton>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import InlineAlign from 'src/components/InlineAlign/InlineAlign.vue';

  export default {
    name: 'ReactionButton',
    components: { InlineAlign, BasicButton },
    props: {
      reaction: {
        type: Object,
        required: true,
      },
      href: String,
      appearance: String,
    }
  }
</script>